export { default as LOCALE_GB } from '@angular/common/locales/en-GB';
export const LOCALE_ID_VALUE = 'en-GB';
export const DEFAULT_LANG = 'en';
export const DEFAULT_TIMEZONE = new Intl.DateTimeFormat().resolvedOptions().timeZone;

export const DEFAULT_TIME_FORMAT = 'hh:mm a';
